import React from "react";

import { makeStyles, withStyles, Popover } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  popoverRoot: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
}));

function KPopover(props) {
  const { children, open, anchorEl, onClose } = props;
  const classes = useStyles();
  return (
    <Popover
      open={open}
      anchorEl={anchorEl}
      anchorReference={"none"}
      onClick={onClose}
      onClose={onClose}
      classes={{
        root: classes.popoverRoot,
      }}
    >
      {children}
    </Popover>
  );
}

// export default KPopover;
export default withStyles(useStyles, { withTheme: true })(KPopover);

/*
 anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'center',
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'center',
      }}*/
